import { useTransitionNavigate } from './PageTransition';
import { BrandMark } from './BrandMark';
import { Hoverable } from './Hoverable';
import { COMPANY } from '../data/content';
import { color, font, maxWidth } from '../styles/tokens';

const linkStyle = { color: color.textDim, font: `400 14px ${font.body}`, background: 'none', border: 'none', textAlign: 'left', padding: 0, cursor: 'pointer' };

export const Footer = () => {
  const navigate = useTransitionNavigate();

  const NavBtn = ({ to, children }) => (
    <Hoverable as="button" onClick={() => navigate(to)} style={linkStyle} hoverStyle={{ color: color.text }}>
      {children}
    </Hoverable>
  );

  return (
    <footer style={{ background: '#05070b', borderTop: '1px solid rgba(255,255,255,.07)', color: color.textDim }}>
      <div
        style={{
          maxWidth,
          margin: '0 auto',
          padding: '64px 28px 44px',
          display: 'flex',
          flexWrap: 'wrap',
          gap: 44,
          justifyContent: 'space-between',
        }}
      >
        <div style={{ maxWidth: 320 }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
            {/* <BrandMark size={36} /> */}
          <img src='/logo192.png' height={36} />
            <span style={{ display: 'flex', flexDirection: 'column', lineHeight: 1 }}>
              <span style={{ font: `700 20px/1 ${font.display}`, color: color.text }}>V-TECH</span>
              <span style={{ font: `500 8px/1 ${font.mono}`, letterSpacing: '.42em', color: color.accent, marginTop: 5 }}>
                INDUSTRIES
              </span>
            </span>
          </div>
          <p style={{ margin: '20px 0 0', font: `400 14px/1.65 ${font.body}`, color: '#6f7a8c' }}>
            Precision-engineered honing tools, industrial brushes, dies &amp; molds, and receiving gauges. Manufactured in IMT
            Manesar since 2012.
          </p>
        </div>

        <div style={{ display: 'flex', gap: 56, flexWrap: 'wrap' }}>
          <div style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
            <span style={{ font: `500 11px ${font.mono}`, letterSpacing: '.12em', color: color.accent }}>EXPLORE</span>
            <NavBtn to="/">Home</NavBtn>
            <NavBtn to="/about">About</NavBtn>
            <NavBtn to="/honing">Honing Solutions</NavBtn>
            <NavBtn to="/products">Products</NavBtn>
          </div>
          <div style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
            <span style={{ font: `500 11px ${font.mono}`, letterSpacing: '.12em', color: color.accent }}>CONTACT</span>
            <Hoverable as="a" href={`mailto:${COMPANY.email}`} style={{ ...linkStyle, cursor: 'auto' }} hoverStyle={{ color: color.text }}>
              {COMPANY.email}
            </Hoverable>
            {COMPANY.phones.map((p) => (
            <Hoverable as="a" key={p} href={`tel:${p}`} style={{ ...linkStyle, cursor: 'auto' }} hoverStyle={{ color: color.text }}>
              {p}
            </Hoverable>
              //             <span key={p} style={{ font: `400 14px ${font.body}`, color: color.textDim }}>
              //   {p}
              // </span>
            ))}
            {/* <Hoverable as="a" href={COMPANY.web} style={{ ...linkStyle, cursor: 'auto' }} hoverStyle={{ color: color.text }}>
              {COMPANY.webLabel}
            </Hoverable> */}
          </div>
        </div>
      </div>

      <div style={{ borderTop: '1px solid rgba(255,255,255,.07)' }}>
        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 14, maxWidth, margin: '0 auto', padding: '20px 28px' }}>
          <div style={{ font: `400 12.5px ${font.body}`, color: color.textFainter }}>
            © 2026 V-Tech Industries · {COMPANY.address}
          </div>
          <a href='https://breydigital.com' style={{ textAlign: 'right',font: `400 12.5px ${font.body}`, color: color.textFainter }}>
            Built by Brey Digital
          </a>
        </div>
      </div>
    </footer>
  );
};
